exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_gettingStated_YYYXFyvtUsPVlQj8S1xRk {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_video_2m-cDqt_2jL7gP4ZfVI7Z1 {\n  position: relative;\n  float: left;\n  width: 300px;\n  height: 169px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_gettingStated": "IA_gettingStated_YYYXFyvtUsPVlQj8S1xRk",
	"IA_video": "IA_video_2m-cDqt_2jL7gP4ZfVI7Z1"
};